import * as v from 'valibot';

import { countrySchema } from '../countries.model';

const optionSchema = v.object({
  id: v.string(),
  label: v.string(),
});

export const locationSearchFormSchema = v.object({
  city: v.optional(v.string()),
  countryCode: v.pipe(
    v.optional(countrySchema),
    v.check((value) => Boolean(value), 'Country is required'),
  ),
  locationCode: v.optional(v.string()),
  portKey: v.optional(v.number()),
  portName: v.optional(v.string()),
  // TODO: clarify whether this maps to the PostalFrom or PostalTo swagger param.
  postalFrom: v.optional(v.string()),
  stateCode: v.optional(optionSchema),
});

export const locationSearchParamsSchema = v.object({
  city: v.optional(v.string()),
  countryCode: v.optional(v.string()),
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  locationCode: v.optional(v.string()),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  portKey: v.optional(v.number()),
  sorting: v.optional(v.string()),
  stateCode: v.optional(v.string()),
});

export const locationSchema = v.object({
  address1: v.nullish(v.string()),
  address2: v.nullish(v.string()),
  city: v.nullish(v.string()),
  countryCode: v.nullish(v.string()),
  countryName: v.nullish(v.string()),
  locationCode: v.nullish(v.string()),
  locationKey: v.number(),
  portKey: v.nullish(v.number()),
  portName: v.nullish(v.string()),
  postalCodeFrom: v.nullish(v.string()),
  postalCodeTo: v.nullish(v.string()),
  stateCode: v.nullish(v.string()),
  stateName: v.nullish(v.string()),
});

export const locationPagedResultSchema = v.object({
  items: v.nullish(v.array(locationSchema)),
  totalCount: v.number(),
});

export type LocationSearchFormValues = v.InferOutput<typeof locationSearchFormSchema>;
export type LocationsParams = v.InferOutput<typeof locationSearchParamsSchema>;
export type LocationItem = v.InferOutput<typeof locationSchema>;
export type LocationPagedResult = v.InferOutput<typeof locationPagedResultSchema>;
export type LocationRow = LocationItem & { id: string };
export type Locations = LocationRow[];
export type LocationsApi = { data: Locations; total: number };
